export default "__VITE_ASSET__BXz1LJhX__"